export const invalidDomains = ['@yahoo.', '@hotmail.', '@hey.'];